import { registerVersion as de, _registerComponent as R, _getProvider as F, getApp as $e } from "@firebase/app";
import { s as Z, a as ee } from "./index-DLl81wX6.mjs";
const te = (e) => {
  const t = {
    hashValue: "",
    isLiveArticle: !1
  };
  try {
    var n;
    const {
      hash: o
    } = new URL(e);
    o != null && (n = o.startsWith) !== null && n !== void 0 && n.call(o, "#live") && (t.hashValue = o, t.isLiveArticle = !0);
  } catch (o) {
    console.error(new Error("Failed to check live article", {
      cause: o
    }));
  }
  return t;
};
function Fe() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function xe() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const o = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(o);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(o), e(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var r;
        t(((r = i.error) === null || r === void 0 ? void 0 : r.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ke = "FirebaseError";
class v extends Error {
  constructor(t, n, o) {
    super(n), this.code = t, this.customData = o, this.name = Ke, Object.setPrototypeOf(this, v.prototype), Error.captureStackTrace && Error.captureStackTrace(this, x.prototype.create);
  }
}
class x {
  constructor(t, n, o) {
    this.service = t, this.serviceName = n, this.errors = o;
  }
  create(t, ...n) {
    const o = n[0] || {}, i = `${this.service}/${t}`, r = this.errors[t], a = r ? Ve(r, o) : "Error", s = `${this.serviceName}: ${a} (${i}).`;
    return new v(i, s, o);
  }
}
function Ve(e, t) {
  return e.replace(qe, (n, o) => {
    const i = t[o];
    return i != null ? String(i) : `<${o}?>`;
  });
}
const qe = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function le(e) {
  return e && e._delegate ? e._delegate : e;
}
class L {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, o) {
    this.name = t, this.instanceFactory = n, this.type = o, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
const Ue = (e, t) => t.some((n) => e instanceof n);
let ne, oe;
function He() {
  return ne || (ne = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function We() {
  return oe || (oe = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const fe = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap();
function Ge(e) {
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("success", r), e.removeEventListener("error", a);
    }, r = () => {
      n(p(e.result)), i();
    }, a = () => {
      o(e.error), i();
    };
    e.addEventListener("success", r), e.addEventListener("error", a);
  });
  return t.then((n) => {
    n instanceof IDBCursor && fe.set(n, e);
  }).catch(() => {
  }), K.set(t, e), t;
}
function Je(e) {
  if (B.has(e))
    return;
  const t = new Promise((n, o) => {
    const i = () => {
      e.removeEventListener("complete", r), e.removeEventListener("error", a), e.removeEventListener("abort", a);
    }, r = () => {
      n(), i();
    }, a = () => {
      o(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", r), e.addEventListener("error", a), e.addEventListener("abort", a);
  });
  B.set(e, t);
}
let j = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return B.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || pe.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return p(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function ze(e) {
  j = e(j);
}
function Ye(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const o = e.call(A(this), t, ...n);
    return pe.set(o, t.sort ? t.sort() : [t]), p(o);
  } : We().includes(e) ? function(...t) {
    return e.apply(A(this), t), p(fe.get(this));
  } : function(...t) {
    return p(e.apply(A(this), t));
  };
}
function Qe(e) {
  return typeof e == "function" ? Ye(e) : (e instanceof IDBTransaction && Je(e), Ue(e, He()) ? new Proxy(e, j) : e);
}
function p(e) {
  if (e instanceof IDBRequest)
    return Ge(e);
  if (_.has(e))
    return _.get(e);
  const t = Qe(e);
  return t !== e && (_.set(e, t), K.set(t, e)), t;
}
const A = (e) => K.get(e);
function V(e, t, { blocked: n, upgrade: o, blocking: i, terminated: r } = {}) {
  const a = indexedDB.open(e, t), s = p(a);
  return o && a.addEventListener("upgradeneeded", (c) => {
    o(p(a.result), c.oldVersion, c.newVersion, p(a.transaction), c);
  }), n && a.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), s.then((c) => {
    r && c.addEventListener("close", () => r()), i && c.addEventListener("versionchange", (d) => i(d.oldVersion, d.newVersion, d));
  }).catch(() => {
  }), s;
}
function E(e, { blocked: t } = {}) {
  const n = indexedDB.deleteDatabase(e);
  return t && n.addEventListener("blocked", (o) => t(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    o.oldVersion,
    o
  )), p(n).then(() => {
  });
}
const Xe = ["get", "getKey", "getAll", "getAllKeys", "count"], Ze = ["put", "add", "delete", "clear"], D = /* @__PURE__ */ new Map();
function ie(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (D.get(t))
    return D.get(t);
  const n = t.replace(/FromIndex$/, ""), o = t !== n, i = Ze.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (o ? IDBIndex : IDBObjectStore).prototype) || !(i || Xe.includes(n))
  )
    return;
  const r = async function(a, ...s) {
    const c = this.transaction(a, i ? "readwrite" : "readonly");
    let d = c.store;
    return o && (d = d.index(s.shift())), (await Promise.all([
      d[n](...s),
      i && c.done
    ]))[0];
  };
  return D.set(t, r), r;
}
ze((e) => ({
  ...e,
  get: (t, n, o) => ie(t, n) || e.get(t, n, o),
  has: (t, n) => !!ie(t, n) || e.has(t, n)
}));
const ge = "@firebase/installations", q = "0.6.7";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const he = 1e4, we = `w:${q}`, be = "FIS_v2", et = "https://firebaseinstallations.googleapis.com/v1", tt = 60 * 60 * 1e3, nt = "installations", ot = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const it = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "not-registered": "Firebase Installation is not registered.",
  "installation-not-found": "Firebase Installation not found.",
  "request-failed": '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  "app-offline": "Could not process request. Application offline.",
  "delete-pending-registration": "Can't delete installation while there is a pending registration request."
}, h = new x(nt, ot, it);
function me(e) {
  return e instanceof v && e.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ye({ projectId: e }) {
  return `${et}/projects/${e}/installations`;
}
function Ie(e) {
  return {
    token: e.token,
    requestStatus: 2,
    expiresIn: st(e.expiresIn),
    creationTime: Date.now()
  };
}
async function ke(e, t) {
  const o = (await t.json()).error;
  return h.create("request-failed", {
    requestName: e,
    serverCode: o.code,
    serverMessage: o.message,
    serverStatus: o.status
  });
}
function ve({ apiKey: e }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
function rt(e, { refreshToken: t }) {
  const n = ve(e);
  return n.append("Authorization", at(t)), n;
}
async function Te(e) {
  const t = await e();
  return t.status >= 500 && t.status < 600 ? e() : t;
}
function st(e) {
  return Number(e.replace("s", "000"));
}
function at(e) {
  return `${be} ${e}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ct({ appConfig: e, heartbeatServiceProvider: t }, { fid: n }) {
  const o = ye(e), i = ve(e), r = t.getImmediate({
    optional: !0
  });
  if (r) {
    const d = await r.getHeartbeatsHeader();
    d && i.append("x-firebase-client", d);
  }
  const a = {
    fid: n,
    authVersion: be,
    appId: e.appId,
    sdkVersion: we
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await Te(() => fetch(o, s));
  if (c.ok) {
    const d = await c.json();
    return {
      fid: d.fid || n,
      registrationStatus: 2,
      refreshToken: d.refreshToken,
      authToken: Ie(d.authToken)
    };
  } else
    throw await ke("Create Installation", c);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Se(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ut(e) {
  return btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const dt = /^[cdef][\w-]{21}$/, $ = "";
function lt() {
  try {
    const e = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;
    const n = ft(e);
    return dt.test(n) ? n : $;
  } catch {
    return $;
  }
}
function ft(e) {
  return ut(e).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function T(e) {
  return `${e.appName}!${e.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _e = /* @__PURE__ */ new Map();
function Ae(e, t) {
  const n = T(e);
  Ee(n, t), pt(n, t);
}
function Ee(e, t) {
  const n = _e.get(e);
  if (n)
    for (const o of n)
      o(t);
}
function pt(e, t) {
  const n = gt();
  n && n.postMessage({ key: e, fid: t }), ht();
}
let g = null;
function gt() {
  return !g && "BroadcastChannel" in self && (g = new BroadcastChannel("[Firebase] FID Change"), g.onmessage = (e) => {
    Ee(e.data.key, e.data.fid);
  }), g;
}
function ht() {
  _e.size === 0 && g && (g.close(), g = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wt = "firebase-installations-database", bt = 1, w = "firebase-installations-store";
let C = null;
function U() {
  return C || (C = V(wt, bt, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(w);
      }
    }
  })), C;
}
async function y(e, t) {
  const n = T(e), i = (await U()).transaction(w, "readwrite"), r = i.objectStore(w), a = await r.get(n);
  return await r.put(t, n), await i.done, (!a || a.fid !== t.fid) && Ae(e, t.fid), t;
}
async function De(e) {
  const t = T(e), o = (await U()).transaction(w, "readwrite");
  await o.objectStore(w).delete(t), await o.done;
}
async function S(e, t) {
  const n = T(e), i = (await U()).transaction(w, "readwrite"), r = i.objectStore(w), a = await r.get(n), s = t(a);
  return s === void 0 ? await r.delete(n) : await r.put(s, n), await i.done, s && (!a || a.fid !== s.fid) && Ae(e, s.fid), s;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function H(e) {
  let t;
  const n = await S(e.appConfig, (o) => {
    const i = mt(o), r = yt(e, i);
    return t = r.registrationPromise, r.installationEntry;
  });
  return n.fid === $ ? { installationEntry: await t } : {
    installationEntry: n,
    registrationPromise: t
  };
}
function mt(e) {
  const t = e || {
    fid: lt(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return Ce(t);
}
function yt(e, t) {
  if (t.registrationStatus === 0) {
    if (!navigator.onLine) {
      const i = Promise.reject(h.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: t,
        registrationPromise: i
      };
    }
    const n = {
      fid: t.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, o = It(e, n);
    return { installationEntry: n, registrationPromise: o };
  } else return t.registrationStatus === 1 ? {
    installationEntry: t,
    registrationPromise: kt(e)
  } : { installationEntry: t };
}
async function It(e, t) {
  try {
    const n = await ct(e, t);
    return y(e.appConfig, n);
  } catch (n) {
    throw me(n) && n.customData.serverCode === 409 ? await De(e.appConfig) : await y(e.appConfig, {
      fid: t.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), n;
  }
}
async function kt(e) {
  let t = await re(e.appConfig);
  for (; t.registrationStatus === 1; )
    await Se(100), t = await re(e.appConfig);
  if (t.registrationStatus === 0) {
    const { installationEntry: n, registrationPromise: o } = await H(e);
    return o || n;
  }
  return t;
}
function re(e) {
  return S(e, (t) => {
    if (!t)
      throw h.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return Ce(t);
  });
}
function Ce(e) {
  return vt(e) ? {
    fid: e.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : e;
}
function vt(e) {
  return e.registrationStatus === 1 && e.registrationTime + he < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Tt({ appConfig: e, heartbeatServiceProvider: t }, n) {
  const o = St(e, n), i = rt(e, n), r = t.getImmediate({
    optional: !0
  });
  if (r) {
    const d = await r.getHeartbeatsHeader();
    d && i.append("x-firebase-client", d);
  }
  const a = {
    installation: {
      sdkVersion: we,
      appId: e.appId
    }
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await Te(() => fetch(o, s));
  if (c.ok) {
    const d = await c.json();
    return Ie(d);
  } else
    throw await ke("Generate Auth Token", c);
}
function St(e, { fid: t }) {
  return `${ye(e)}/${t}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function W(e, t = !1) {
  let n;
  const o = await S(e.appConfig, (r) => {
    if (!Me(r))
      throw h.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const a = r.authToken;
    if (!t && Et(a))
      return r;
    if (a.requestStatus === 1)
      return n = _t(e, t), r;
    {
      if (!navigator.onLine)
        throw h.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const s = Ct(r);
      return n = At(e, s), s;
    }
  });
  return n ? await n : o.authToken;
}
async function _t(e, t) {
  let n = await se(e.appConfig);
  for (; n.authToken.requestStatus === 1; )
    await Se(100), n = await se(e.appConfig);
  const o = n.authToken;
  return o.requestStatus === 0 ? W(e, t) : o;
}
function se(e) {
  return S(e, (t) => {
    if (!Me(t))
      throw h.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const n = t.authToken;
    return Mt(n) ? Object.assign(Object.assign({}, t), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : t;
  });
}
async function At(e, t) {
  try {
    const n = await Tt(e, t), o = Object.assign(Object.assign({}, t), { authToken: n });
    return await y(e.appConfig, o), n;
  } catch (n) {
    if (me(n) && (n.customData.serverCode === 401 || n.customData.serverCode === 404))
      await De(e.appConfig);
    else {
      const o = Object.assign(Object.assign({}, t), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await y(e.appConfig, o);
    }
    throw n;
  }
}
function Me(e) {
  return e !== void 0 && e.registrationStatus === 2;
}
function Et(e) {
  return e.requestStatus === 2 && !Dt(e);
}
function Dt(e) {
  const t = Date.now();
  return t < e.creationTime || e.creationTime + e.expiresIn < t + tt;
}
function Ct(e) {
  const t = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, e), { authToken: t });
}
function Mt(e) {
  return e.requestStatus === 1 && e.requestTime + he < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ot(e) {
  const t = e, { installationEntry: n, registrationPromise: o } = await H(t);
  return o ? o.catch(console.error) : W(t).catch(console.error), n.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Nt(e, t = !1) {
  const n = e;
  return await Pt(n), (await W(n, t)).token;
}
async function Pt(e) {
  const { registrationPromise: t } = await H(e);
  t && await t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Rt(e) {
  if (!e || !e.options)
    throw M("App Configuration");
  if (!e.name)
    throw M("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const n of t)
    if (!e.options[n])
      throw M(n);
  return {
    appName: e.name,
    projectId: e.options.projectId,
    apiKey: e.options.apiKey,
    appId: e.options.appId
  };
}
function M(e) {
  return h.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Oe = "installations", Lt = "installations-internal", Bt = (e) => {
  const t = e.getProvider("app").getImmediate(), n = Rt(t), o = F(t, "heartbeat");
  return {
    app: t,
    appConfig: n,
    heartbeatServiceProvider: o,
    _delete: () => Promise.resolve()
  };
}, jt = (e) => {
  const t = e.getProvider("app").getImmediate(), n = F(t, Oe).getImmediate();
  return {
    getId: () => Ot(n),
    getToken: (i) => Nt(n, i)
  };
};
function $t() {
  R(new L(
    Oe,
    Bt,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), R(new L(
    Lt,
    jt,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
$t();
de(ge, q);
de(ge, q, "esm2017");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ne = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4", Ft = "https://fcmregistrations.googleapis.com/v1", Pe = "FCM_MSG", xt = "google.c.a.c_id", Kt = 3, Vt = 1;
var I;
(function(e) {
  e[e.DATA_MESSAGE = 1] = "DATA_MESSAGE", e[e.DISPLAY_NOTIFICATION = 3] = "DISPLAY_NOTIFICATION";
})(I || (I = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var k;
(function(e) {
  e.PUSH_RECEIVED = "push-received", e.NOTIFICATION_CLICKED = "notification-clicked";
})(k || (k = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function f(e) {
  const t = new Uint8Array(e);
  return btoa(String.fromCharCode(...t)).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function qt(e) {
  const t = "=".repeat((4 - e.length % 4) % 4), n = (e + t).replace(/\-/g, "+").replace(/_/g, "/"), o = atob(n), i = new Uint8Array(o.length);
  for (let r = 0; r < o.length; ++r)
    i[r] = o.charCodeAt(r);
  return i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const O = "fcm_token_details_db", Ut = 5, ae = "fcm_token_object_Store";
async function Ht(e) {
  if ("databases" in indexedDB && !(await indexedDB.databases()).map((r) => r.name).includes(O))
    return null;
  let t = null;
  return (await V(O, Ut, {
    upgrade: async (o, i, r, a) => {
      var s;
      if (i < 2 || !o.objectStoreNames.contains(ae))
        return;
      const c = a.objectStore(ae), d = await c.index("fcmSenderId").get(e);
      if (await c.clear(), !!d) {
        if (i === 2) {
          const u = d;
          if (!u.auth || !u.p256dh || !u.endpoint)
            return;
          t = {
            token: u.fcmToken,
            createTime: (s = u.createTime) !== null && s !== void 0 ? s : Date.now(),
            subscriptionOptions: {
              auth: u.auth,
              p256dh: u.p256dh,
              endpoint: u.endpoint,
              swScope: u.swScope,
              vapidKey: typeof u.vapidKey == "string" ? u.vapidKey : f(u.vapidKey)
            }
          };
        } else if (i === 3) {
          const u = d;
          t = {
            token: u.fcmToken,
            createTime: u.createTime,
            subscriptionOptions: {
              auth: f(u.auth),
              p256dh: f(u.p256dh),
              endpoint: u.endpoint,
              swScope: u.swScope,
              vapidKey: f(u.vapidKey)
            }
          };
        } else if (i === 4) {
          const u = d;
          t = {
            token: u.fcmToken,
            createTime: u.createTime,
            subscriptionOptions: {
              auth: f(u.auth),
              p256dh: f(u.p256dh),
              endpoint: u.endpoint,
              swScope: u.swScope,
              vapidKey: f(u.vapidKey)
            }
          };
        }
      }
    }
  })).close(), await E(O), await E("fcm_vapid_details_db"), await E("undefined"), Wt(t) ? t : null;
}
function Wt(e) {
  if (!e || !e.subscriptionOptions)
    return !1;
  const { subscriptionOptions: t } = e;
  return typeof e.createTime == "number" && e.createTime > 0 && typeof e.token == "string" && e.token.length > 0 && typeof t.auth == "string" && t.auth.length > 0 && typeof t.p256dh == "string" && t.p256dh.length > 0 && typeof t.endpoint == "string" && t.endpoint.length > 0 && typeof t.swScope == "string" && t.swScope.length > 0 && typeof t.vapidKey == "string" && t.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gt = "firebase-messaging-database", Jt = 1, b = "firebase-messaging-store";
let N = null;
function G() {
  return N || (N = V(Gt, Jt, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(b);
      }
    }
  })), N;
}
async function J(e) {
  const t = Y(e), o = await (await G()).transaction(b).objectStore(b).get(t);
  if (o)
    return o;
  {
    const i = await Ht(e.appConfig.senderId);
    if (i)
      return await z(e, i), i;
  }
}
async function z(e, t) {
  const n = Y(e), i = (await G()).transaction(b, "readwrite");
  return await i.objectStore(b).put(t, n), await i.done, t;
}
async function zt(e) {
  const t = Y(e), o = (await G()).transaction(b, "readwrite");
  await o.objectStore(b).delete(t), await o.done;
}
function Y({ appConfig: e }) {
  return e.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Yt = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "only-available-in-window": "This method is available in a Window context.",
  "only-available-in-sw": "This method is available in a service worker context.",
  "permission-default": "The notification permission was not granted and dismissed instead.",
  "permission-blocked": "The notification permission was not granted and blocked instead.",
  "unsupported-browser": "This browser doesn't support the API's required to use the Firebase SDK.",
  "indexed-db-unsupported": "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
  "failed-service-worker-registration": "We are unable to register the default service worker. {$browserErrorMessage}",
  "token-subscribe-failed": "A problem occurred while subscribing the user to FCM: {$errorInfo}",
  "token-subscribe-no-token": "FCM returned no token when subscribing the user to push.",
  "token-unsubscribe-failed": "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
  "token-update-failed": "A problem occurred while updating the user from FCM: {$errorInfo}",
  "token-update-no-token": "FCM returned no token when updating the user to push.",
  "use-sw-after-get-token": "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
  "invalid-sw-registration": "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
  "invalid-bg-handler": "The input to setBackgroundMessageHandler() must be a function.",
  "invalid-vapid-key": "The public VAPID key must be a string.",
  "use-vapid-key-after-get-token": "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
}, l = new x("messaging", "Messaging", Yt);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Qt(e, t) {
  const n = await X(e), o = Le(t), i = {
    method: "POST",
    headers: n,
    body: JSON.stringify(o)
  };
  let r;
  try {
    r = await (await fetch(Q(e.appConfig), i)).json();
  } catch (a) {
    throw l.create("token-subscribe-failed", {
      errorInfo: a == null ? void 0 : a.toString()
    });
  }
  if (r.error) {
    const a = r.error.message;
    throw l.create("token-subscribe-failed", {
      errorInfo: a
    });
  }
  if (!r.token)
    throw l.create(
      "token-subscribe-no-token"
      /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */
    );
  return r.token;
}
async function Xt(e, t) {
  const n = await X(e), o = Le(t.subscriptionOptions), i = {
    method: "PATCH",
    headers: n,
    body: JSON.stringify(o)
  };
  let r;
  try {
    r = await (await fetch(`${Q(e.appConfig)}/${t.token}`, i)).json();
  } catch (a) {
    throw l.create("token-update-failed", {
      errorInfo: a == null ? void 0 : a.toString()
    });
  }
  if (r.error) {
    const a = r.error.message;
    throw l.create("token-update-failed", {
      errorInfo: a
    });
  }
  if (!r.token)
    throw l.create(
      "token-update-no-token"
      /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */
    );
  return r.token;
}
async function Re(e, t) {
  const o = {
    method: "DELETE",
    headers: await X(e)
  };
  try {
    const r = await (await fetch(`${Q(e.appConfig)}/${t}`, o)).json();
    if (r.error) {
      const a = r.error.message;
      throw l.create("token-unsubscribe-failed", {
        errorInfo: a
      });
    }
  } catch (i) {
    throw l.create("token-unsubscribe-failed", {
      errorInfo: i == null ? void 0 : i.toString()
    });
  }
}
function Q({ projectId: e }) {
  return `${Ft}/projects/${e}/registrations`;
}
async function X({ appConfig: e, installations: t }) {
  const n = await t.getToken();
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e.apiKey,
    "x-goog-firebase-installations-auth": `FIS ${n}`
  });
}
function Le({ p256dh: e, auth: t, endpoint: n, vapidKey: o }) {
  const i = {
    web: {
      endpoint: n,
      auth: t,
      p256dh: e
    }
  };
  return o !== Ne && (i.web.applicationPubKey = o), i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zt = 7 * 24 * 60 * 60 * 1e3;
async function en(e) {
  const t = await nn(e.swRegistration, e.vapidKey), n = {
    vapidKey: e.vapidKey,
    swScope: e.swRegistration.scope,
    endpoint: t.endpoint,
    auth: f(t.getKey("auth")),
    p256dh: f(t.getKey("p256dh"))
  }, o = await J(e.firebaseDependencies);
  if (o) {
    if (on(o.subscriptionOptions, n))
      return Date.now() >= o.createTime + Zt ? tn(e, {
        token: o.token,
        createTime: Date.now(),
        subscriptionOptions: n
      }) : o.token;
    try {
      await Re(e.firebaseDependencies, o.token);
    } catch (i) {
      console.warn(i);
    }
    return ue(e.firebaseDependencies, n);
  } else return ue(e.firebaseDependencies, n);
}
async function ce(e) {
  const t = await J(e.firebaseDependencies);
  t && (await Re(e.firebaseDependencies, t.token), await zt(e.firebaseDependencies));
  const n = await e.swRegistration.pushManager.getSubscription();
  return n ? n.unsubscribe() : !0;
}
async function tn(e, t) {
  try {
    const n = await Xt(e.firebaseDependencies, t), o = Object.assign(Object.assign({}, t), { token: n, createTime: Date.now() });
    return await z(e.firebaseDependencies, o), n;
  } catch (n) {
    throw n;
  }
}
async function ue(e, t) {
  const o = {
    token: await Qt(e, t),
    createTime: Date.now(),
    subscriptionOptions: t
  };
  return await z(e, o), o.token;
}
async function nn(e, t) {
  const n = await e.pushManager.getSubscription();
  return n || e.pushManager.subscribe({
    userVisibleOnly: !0,
    // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
    // submitted to pushManager#subscribe must be of type Uint8Array.
    applicationServerKey: qt(t)
  });
}
function on(e, t) {
  const n = t.vapidKey === e.vapidKey, o = t.endpoint === e.endpoint, i = t.auth === e.auth, r = t.p256dh === e.p256dh;
  return n && o && i && r;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function rn(e) {
  const t = {
    from: e.from,
    // eslint-disable-next-line camelcase
    collapseKey: e.collapse_key,
    // eslint-disable-next-line camelcase
    messageId: e.fcmMessageId
  };
  return sn(t, e), an(t, e), cn(t, e), t;
}
function sn(e, t) {
  if (!t.notification)
    return;
  e.notification = {};
  const n = t.notification.title;
  n && (e.notification.title = n);
  const o = t.notification.body;
  o && (e.notification.body = o);
  const i = t.notification.image;
  i && (e.notification.image = i);
  const r = t.notification.icon;
  r && (e.notification.icon = r);
}
function an(e, t) {
  t.data && (e.data = t.data);
}
function cn(e, t) {
  var n, o, i, r, a;
  if (!t.fcmOptions && !(!((n = t.notification) === null || n === void 0) && n.click_action))
    return;
  e.fcmOptions = {};
  const s = (i = (o = t.fcmOptions) === null || o === void 0 ? void 0 : o.link) !== null && i !== void 0 ? i : (r = t.notification) === null || r === void 0 ? void 0 : r.click_action;
  s && (e.fcmOptions.link = s);
  const c = (a = t.fcmOptions) === null || a === void 0 ? void 0 : a.analytics_label;
  c && (e.fcmOptions.analyticsLabel = c);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function un(e) {
  return typeof e == "object" && !!e && xt in e;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function dn(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Be("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
Be("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
async function ln(e, t) {
  const n = fn(t, await e.firebaseDependencies.installations.getId());
  pn(e, n, t.productId);
}
function fn(e, t) {
  var n, o;
  const i = {};
  return e.from && (i.project_number = e.from), e.fcmMessageId && (i.message_id = e.fcmMessageId), i.instance_id = t, e.notification ? i.message_type = I.DISPLAY_NOTIFICATION.toString() : i.message_type = I.DATA_MESSAGE.toString(), i.sdk_platform = Kt.toString(), i.package_name = self.origin.replace(/(^\w+:|^)\/\//, ""), e.collapse_key && (i.collapse_key = e.collapse_key), i.event = Vt.toString(), !((n = e.fcmOptions) === null || n === void 0) && n.analytics_label && (i.analytics_label = (o = e.fcmOptions) === null || o === void 0 ? void 0 : o.analytics_label), i;
}
function pn(e, t, n) {
  const o = {};
  o.event_time_ms = Math.floor(Date.now()).toString(), o.source_extension_json_proto3 = JSON.stringify(t), n && (o.compliance_data = gn(n)), e.logEvents.push(o);
}
function gn(e) {
  return {
    privacy_context: {
      prequest: {
        origin_associated_product_id: e
      }
    }
  };
}
function Be(e, t) {
  const n = [];
  for (let o = 0; o < e.length; o++)
    n.push(e.charAt(o)), o < t.length && n.push(t.charAt(o));
  return n.join("");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function hn(e, t) {
  var n, o;
  const { newSubscription: i } = e;
  if (!i) {
    await ce(t);
    return;
  }
  const r = await J(t.firebaseDependencies);
  await ce(t), t.vapidKey = (o = (n = r == null ? void 0 : r.subscriptionOptions) === null || n === void 0 ? void 0 : n.vapidKey) !== null && o !== void 0 ? o : Ne, await en(t);
}
async function wn(e, t) {
  const n = yn(e);
  if (!n)
    return;
  t.deliveryMetricsExportedToBigQueryEnabled && await ln(t, n);
  const o = await je();
  if (kn(o))
    return vn(o, n);
  if (n.notification && await Tn(mn(n)), !!t && t.onBackgroundMessageHandler) {
    const i = rn(n);
    typeof t.onBackgroundMessageHandler == "function" ? await t.onBackgroundMessageHandler(i) : t.onBackgroundMessageHandler.next(i);
  }
}
async function bn(e) {
  var t, n;
  const o = (n = (t = e.notification) === null || t === void 0 ? void 0 : t.data) === null || n === void 0 ? void 0 : n[Pe];
  if (o) {
    if (e.action)
      return;
  } else return;
  e.stopImmediatePropagation(), e.notification.close();
  const i = Sn(o);
  if (!i)
    return;
  const r = new URL(i, self.location.href), a = new URL(self.location.origin);
  if (r.host !== a.host)
    return;
  let s = await In(r);
  if (s ? s = await s.focus() : (s = await self.clients.openWindow(i), await dn(3e3)), !!s)
    return o.messageType = k.NOTIFICATION_CLICKED, o.isFirebaseMessaging = !0, s.postMessage(o);
}
function mn(e) {
  const t = Object.assign({}, e.notification);
  return t.data = {
    [Pe]: e
  }, t;
}
function yn({ data: e }) {
  if (!e)
    return null;
  try {
    return e.json();
  } catch {
    return null;
  }
}
async function In(e) {
  const t = await je();
  for (const n of t) {
    const o = new URL(n.url, self.location.href);
    if (e.host === o.host)
      return n;
  }
  return null;
}
function kn(e) {
  return e.some((t) => t.visibilityState === "visible" && // Ignore chrome-extension clients as that matches the background pages of extensions, which
  // are always considered visible for some reason.
  !t.url.startsWith("chrome-extension://"));
}
function vn(e, t) {
  t.isFirebaseMessaging = !0, t.messageType = k.PUSH_RECEIVED;
  for (const n of e)
    n.postMessage(t);
}
function je() {
  return self.clients.matchAll({
    type: "window",
    includeUncontrolled: !0
    // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
  });
}
function Tn(e) {
  var t;
  const { actions: n } = e, { maxActions: o } = Notification;
  return n && o && n.length > o && console.warn(`This browser only supports ${o} actions. The remaining actions will not be displayed.`), self.registration.showNotification(
    /* title= */
    (t = e.title) !== null && t !== void 0 ? t : "",
    e
  );
}
function Sn(e) {
  var t, n, o;
  const i = (n = (t = e.fcmOptions) === null || t === void 0 ? void 0 : t.link) !== null && n !== void 0 ? n : (o = e.notification) === null || o === void 0 ? void 0 : o.click_action;
  return i || (un(e.data) ? self.location.origin : null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _n(e) {
  if (!e || !e.options)
    throw P("App Configuration Object");
  if (!e.name)
    throw P("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId",
    "messagingSenderId"
  ], { options: n } = e;
  for (const o of t)
    if (!n[o])
      throw P(o);
  return {
    appName: e.name,
    projectId: n.projectId,
    apiKey: n.apiKey,
    appId: n.appId,
    senderId: n.messagingSenderId
  };
}
function P(e) {
  return l.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class An {
  constructor(t, n, o) {
    this.deliveryMetricsExportedToBigQueryEnabled = !1, this.onBackgroundMessageHandler = null, this.onMessageHandler = null, this.logEvents = [], this.isLogServiceStarted = !1;
    const i = _n(t);
    this.firebaseDependencies = {
      app: t,
      appConfig: i,
      installations: n,
      analyticsProvider: o
    };
  }
  _delete() {
    return Promise.resolve();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const En = (e) => {
  const t = new An(e.getProvider("app").getImmediate(), e.getProvider("installations-internal").getImmediate(), e.getProvider("analytics-internal"));
  return self.addEventListener("push", (n) => {
    n.waitUntil(wn(n, t));
  }), self.addEventListener("pushsubscriptionchange", (n) => {
    n.waitUntil(hn(n, t));
  }), self.addEventListener("notificationclick", (n) => {
    n.waitUntil(bn(n));
  }), t;
};
function Dn() {
  R(new L(
    "messaging-sw",
    En,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Cn() {
  return Fe() && await xe() && "PushManager" in self && "Notification" in self && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Mn(e, t) {
  if (self.document !== void 0)
    throw l.create(
      "only-available-in-sw"
      /* ErrorCode.AVAILABLE_IN_SW */
    );
  return e.onBackgroundMessageHandler = t, () => {
    e.onBackgroundMessageHandler = null;
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function On(e = $e()) {
  return Cn().then((t) => {
    if (!t)
      throw l.create(
        "unsupported-browser"
        /* ErrorCode.UNSUPPORTED_BROWSER */
      );
  }, (t) => {
    throw l.create(
      "indexed-db-unsupported"
      /* ErrorCode.INDEXED_DB_UNSUPPORTED */
    );
  }), F(le(e), "messaging-sw").getImmediate();
}
function Nn(e, t) {
  return e = le(e), Mn(e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Dn();
function Ln(e, t, n, o) {
  const i = On(e);
  self.addEventListener("notificationclick", (r) => {
    const a = async () => {
      try {
        if (!r) return;
        r.notification.close();
        const s = r.notification.data;
        if (!s) return;
        const c = await self.registration.pushManager.getSubscription();
        if (c === null)
          throw new Error("No subscription currently available.");
        const {
          hashValue: d,
          isLiveArticle: u
        } = te(s.click_action);
        await Z({
          clientId: c.endpoint,
          event: u ? {
            action: "Push Notification/Click to Open",
            category: "Push Notification PWA",
            label: `${s.topic},${s.nid},${s.push_time}`
          } : {
            action: "Push Notification/Click to Open",
            category: "Live Blog Push PWA",
            label: `Live,${s.nid},${s.push_time}`
          },
          trackingId: t
        }), await ee({
          clientId: c.endpoint,
          event: {
            action: "click",
            category: "push",
            customized_parameters: {
              article_id: s.nid,
              push_time: s.push_time,
              section: s.topic
            },
            subcategory: "received"
          },
          measurementApiKey: n,
          measurementId: o
        });
        const m = new URL(s.click_action);
        return m.searchParams.append("utm_source", "firebase_pwa"), m.searchParams.append("utm_medium", "push_notification"), m.searchParams.append("utm_campaign", "article"), m.searchParams.append("utm_content", `${s.nid}${d}`), self.clients.openWindow(m.toString());
      } catch (s) {
        console.error(new Error("Failed to handle notification click", {
          cause: s
        }));
      }
    };
    r.waitUntil(a());
  }), Nn(i, (r) => {
    (async () => {
      try {
        const s = r.data;
        if (!s) return;
        const c = await self.registration.pushManager.getSubscription();
        if (c === null)
          throw new Error("No subscription currently available.");
        const {
          isLiveArticle: d
        } = te(s.click_action);
        return await Z({
          clientId: c.endpoint,
          event: d ? {
            action: "Push Notification/Received",
            category: "Live Blog Push PWA",
            label: `Live,${s.nid},${s.push_time}`
          } : {
            action: "Push Notification/Received",
            category: "Push Notification PWA",
            label: `${s.topic},${s.nid},${s.push_time}`
          },
          trackingId: t
        }), await ee({
          clientId: c.endpoint,
          event: {
            action: "sys",
            category: "push",
            customized_parameters: {
              article_id: s.nid,
              push_time: s.push_time,
              section: s.topic
            },
            subcategory: "received"
          },
          measurementApiKey: n,
          measurementId: o
        }), self.registration.showNotification(s.title, {
          body: s.body,
          data: s,
          icon: s.icon,
          tag: s.nid
        });
      } catch (s) {
        console.error(new Error("Failed to handle firebase background message", {
          cause: s
        }));
      }
    })();
  });
}
export {
  te as c,
  Ln as i
};
//# sourceMappingURL=index-rLJ7Bey3.mjs.map
